import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  ui: {
    loading: false,
    creating: false,
  },
  address: [],
};
export const groupDetailsReducerSlice = createSlice({
  name: 'groupDetails',
  initialState,
  reducers: {
    get_address: (state) => {
      state.ui.loading = true;
    },
    get_address_success: (state, { payload }) => {
      state.ui.loading = false;
      state.address = payload;
    },
    get_address_error: (state) => {
      state.ui.loading = false;
    },
    create_address: (state) => {
      state.ui.creating = true;
    },
    create_address_success: (state) => {
      state.ui.creating = false;
    },
    create_address_error: (state) => {
      state.ui.creating = false;
    },

    update_address: (state) => {
      state.ui.creating = true;
    },
    update_address_success: (state) => {
      state.ui.creating = false;
    },
    update_address_error: (state) => {
      state.ui.creating = false;
    },
    delete_address: (state) => {
      state.ui.creating = true;
    },
    delete_address_success: (state, { payload }) => {
      state.ui.creating = false;
      state.address = state.address.filter((data) => data._id !== payload._id);
    },
    delete_address_error: (state) => {
      state.ui.creating = false;
    },

    pay_for_basket: (state) => {
      state.ui.creating = true;
    },
    pay_for_basket_success: (state) => {
      state.ui.creating = false;
    },
    pay_for_basket_error: (state) => {
      state.ui.creating = false;
    },
  },
});

// Action creators are generated for each case reducer function

export const {
  get_address,
  get_address_success,
  get_address_error,
  create_address,
  create_address_success,
  create_address_error,
  update_address,
  update_address_success,
  update_address_error,
  delete_address,
  delete_address_success,
  delete_address_error,
  pay_for_basket,
  pay_for_basket_success,
  pay_for_basket_error,
} = groupDetailsReducerSlice.actions;

export default groupDetailsReducerSlice.reducer;
